export const openUrlInNewTab = ({ url, title }) => {
  const w = window.open(url, '_blank');

  if (w) {
    setTimeout(() => {
      w.document.title = title;
    }, 300);
  } else {
    //если всплывающее окно заблокировано, фолбэк: создать ссылку и кликнуть
    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
